import ApiClient from "../helpers/ApiClient";

export const getPartnersAccMngData = async () => {
    try {
        const response = await ApiClient.get(`/homePage/homePage/getPartner`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const addPartnersAccMngData = async ({ partner_name, url, file }) => {
    try {
        const response = await ApiClient.post(`/homePage/homePage/addPartner`,
            { partner_name, url, file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editPartnersAccMngData = async ({ id, partner_name, url, file }) => {

    try {
        const response = await ApiClient.put(`/homePage/homePage/updatePartner/${id}`,
            { partner_name, url, file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deletePartnerData = async ({ id }) => {
    try {
        const response = await ApiClient.put(`homePage/homePage/deletePartner/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}
